import React from "react";
import {
    CreateCounterpartyAddressBody,
    CounterpartyAddress,
} from "@common/schemas/counterpartyAddress.schema";
import { StandardModal, StandardModalHeader } from "@design-system/Modal/Modal";
import { CounterpartyAddressForm } from "./CounterpartyAddressForm";

interface Props {
    show: boolean;
    address?: CounterpartyAddress;
    onSubmit: (body: CreateCounterpartyAddressBody) => Promise<void>;
    onHide: () => void;
}

export const CounterpartyAddressModal: React.FC<Props> = ({
    show,
    address,
    onSubmit,
    onHide,
}) => (
    <StandardModal show={show} onHide={onHide} size="md">
        <StandardModalHeader>
            {address ? "Edit address" : "Add address"}
        </StandardModalHeader>
        <CounterpartyAddressForm
            key={address?.id ?? "new"}
            address={address}
            submitText={address ? "Save" : "Add"}
            onSubmit={onSubmit}
            onCancelled={onHide}
        />
    </StandardModal>
);
